import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MapPin, Calendar, Users } from 'lucide-react';

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.6, ease: 'easeOut' }
  }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};

const Hero = () => {
  return (
    <div id="accueil" className="relative min-h-screen">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url("https://iili.io/335Ygaf.jpg")',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/50 to-black/80" />
      </div>
      
      <motion.div 
        initial="hidden"
        animate="visible"
        variants={staggerContainer}
        className="relative min-h-screen flex flex-col items-center justify-center text-center text-white px-4 py-20"
      >
        <motion.div 
          variants={fadeIn}
          className="mb-4 flex flex-wrap justify-center gap-3"
        >
          <span className="inline-flex items-center bg-blue-900/90 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-medium shadow-lg border border-blue-800/30">
            <MapPin className="w-4 h-4 mr-2" /> 
            Maroc
          </span>
          <span className="inline-flex items-center bg-blue-900/90 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-medium shadow-lg border border-blue-800/30">
            <Calendar className="w-4 h-4 mr-2" />
            Départs réguliers
          </span>
          <span className="inline-flex items-center bg-blue-900/90 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-medium shadow-lg border border-blue-800/30">
            <Users className="w-4 h-4 mr-2" />
            4-8 pers.
          </span>
        </motion.div>

        <motion.h1 
          variants={fadeIn}
          className="text-4xl sm:text-5xl md:text-7xl font-display font-bold mb-6 max-w-4xl leading-tight"
        >
          Voyager ensemble, au-delà des{' '}
          <span className="relative inline-block">
            <span className="relative z-10 text-blue-300">frontières</span>
            <span className="absolute bottom-0 left-0 w-full h-1 bg-blue-300/30"></span>
          </span>{' '}
          humaines
        </motion.h1>

        <motion.p 
          variants={fadeIn}
          className="text-xl sm:text-2xl md:text-3xl mb-12 max-w-2xl opacity-90 font-light"
        >
          Découvrez l'authenticité du Maroc à travers des voyages uniques et personnalisés
        </motion.p>

        <motion.div 
          variants={fadeIn}
          className="flex flex-col sm:flex-row gap-4 w-full max-w-md mx-auto"
        >
          <a
            href="#circuits"
            className="w-full sm:flex-1 bg-blue-900 hover:bg-blue-800 text-white px-6 py-3 rounded-full text-lg font-semibold transition-all transform hover:scale-105 shadow-lg border border-blue-800/50 flex items-center justify-center group"
          >
            Voir nos circuits
            <span className="ml-2 group-hover:translate-x-1 transition-transform">→</span>
          </a>
          <a
            href="tel:+33627495066"
            className="w-full sm:flex-1 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border border-white/50 px-6 py-3 rounded-full text-lg font-semibold transition-all flex items-center justify-center transform hover:scale-105 shadow-lg"
          >
            <Phone className="w-5 h-5 mr-2" />
            06 27 49 50 66
          </a>
        </motion.div>
      </motion.div>

      <div className="absolute inset-0 bg-gradient-radial from-transparent via-transparent to-black/20 pointer-events-none"></div>
    </div>
  );
};

export default Hero;